'use strict';

(function ($, Drupal) {
  /*
  // auto submit offers exposed filter on change
  Drupal.behaviors.initOffersExposedFilters = {
  	attach: function (context, settings) {
  		var formContainer, form;
  		formContainer = $('.view-offers-card-grid');
  		if ( formContainer.length ) {
  			form = formContainer.find('.views-exposed-form');
  			$('.form-select', form).on('change', function () {
  				form.find('input.form-submit').once().click();
  			});
  		}
  	}
  };
  	// auto submit testimonials on change
  Drupal.behaviors.initAccoladesExposedFilters = {
  	attach: function (context, settings) {
  		var formContainer, form;
  		formContainer = $('.view-accolades');
  		if ( formContainer.length ) {
  			form = formContainer.find('.views-exposed-form');
  			$('.form-select', form).on('change', function () {
  				form.find('input.form-submit').once().click();
  			});
  		}
  	}
  };
    // Init posts exposed filters.
   Drupal.behaviors.initPostsExposedFilters = {
     attach: function (context, settings) {
       var formContainer, form;
       formContainer = $('.view-posts');
       if ( formContainer.length ) {
         form = formContainer.find('.views-exposed-form');
         $('.form-clear', form).click(function () {
           $('.form-text', form).val("");
         });
       }
     }
   };
   */

  // Details tag.
  Drupal.behaviors.formDetails = {
    loaded: false,
    details: [],
    currentDetails: null,
    attach: function attach(context, settings) {
      Drupal.behaviors.formDetails.details = document.querySelectorAll('.views-exposed-form details');
      if (!Drupal.behaviors.formDetails.loaded && Drupal.behaviors.formDetails.details.length > 0) {
        Drupal.behaviors.formDetails.loaded = true;
        var detailsState = function detailsState(event) {
          var isClickEvent = event && event.type === 'click';
          if (isClickEvent) {
            var clickedElement = isClickEvent ? event.target : null;
            var noDetailContained = true;
            Drupal.behaviors.formDetails.details.forEach(function (detail) {
              if (!detail.contains(clickedElement)) {
                detail.removeAttribute('open');
              } else {
                noDetailContained = false;
                Drupal.behaviors.formDetails.currentDetails = detail.dataset.drupalSelector;
              }
            });
            if (noDetailContained) {
              Drupal.behaviors.formDetails.currentDetails = null;
            }
          } else {
            Drupal.behaviors.formDetails.details.forEach(function (detail) {
              if (Drupal.behaviors.formDetails.currentDetails === null || Drupal.behaviors.formDetails.currentDetails !== detail.dataset.drupalSelector) {
                detail.removeAttribute('open');
              }
            });
          }
        };
        window.addEventListener('click', detailsState, false);
        window.addEventListener('load', detailsState, false);

        document.querySelectorAll('details').forEach(function (D, _, A) {
          D.ontoggle = function () {
            if (D.open) {
              A.forEach(function (d) {
                if (d != D) {
                  d.open = false;
                }
              });
            }
          };
        });

        detailsState();

        $(document).on('ajaxComplete', function (event, xhr, settings) {
          if (settings.extraData && settings.extraData.hasOwnProperty('view_display_id') && settings.extraData.view_display_id === 'block_1' && settings.extraData.hasOwnProperty('view_name') && settings.extraData.view_name === 'hotel_room_listings') {
            detailsState();
          }
        });
      }
    }
  };

  Drupal.behaviors.newsletterSubmission = {
    attach: function attach(context, settings) {
      $(document).ready(function ($) {
        $('form.webform-submission-mailchimp-form').on('submit', function () {
          $(this).find(':input[type=submit]').prop('disabled', true);
        });
      });
    }
  };
})(jQuery, Drupal);